<!-- Login Form Starts -->
<div class="ui basic segment">
  <form class="ui form" [formGroup]="userLoginForm">
    <div class="ui basic segment">
      <h3 class="ui header">Login to your account</h3>
    </div>
    <!-- Social Login Buttons  -->
    <signgaze-social-login></signgaze-social-login>
    <!-- Social Login Ends  -->
    <h3 class="ui horizontal divider segment">or login with</h3>
    <div
      class="field left aligned"
      [class.error]="
        userLoginForm?.controls.email.errors && userLoginForm.get('email').dirty
      "
    >
      <div class="ui large input">
        <input type="text" placeholder="Your Email" formControlName="email" />
      </div>
    </div>
    <div class="field">
      {{ (userLoginForm?.controls.password)['errorMessage'] }}
      <div
        class="ui fluid icon large input"
        [class.error]="
          (userLoginForm?.controls.password)['errorMessage'] !== '' &&
          userLoginForm?.get('password').dirty
        "
      >
        <input
          type="Password"
          placeholder="Password"
          formControlName="password"
          #password
        />
        <a
          href="javascript:void(0)"
          (click)="getPasswordInput(password)"
          class="field-icon"
          ><i class="eye icon"></i
        ></a>
      </div>
    </div>
    <div class="ui grid">
      <div
        class="left floated sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column"
      >
        <button
          class="ui secondary tertiary button"
          (click)="changeLoginView(loginView.FORGOT_PASSWORD)"
        >
          Forgot Password?
        </button>
      </div>
      <div
        class="sixteen-wide-mobile sixteen-wide-tablet five-wide-computer column"
      >
        <button
          class="ui large secondary right floated circular fluid button"
          [ngClass]="{ 'elastic loading': isSubmitted }"
          [disabled]="!userLoginForm?.valid || password.value === ''"
          (click)="loginInWithEmailPassword()"
        >
          Login
        </button>
        <div
          class="ui segment center aligned mob-register"
          (click)="changeLoginView(loginView.REGISTRATION)"
        >
          <button class="ui secondary tertiary button">
            Don't have an account? Sign Up
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- Login Form Ends -->
